module.exports = __webpack_public_path__ + "videos/Gritify_Talent_en.d279808.mp4";